export * from './cn';
export * from './console';
export * from './create-safe-context';
export * from './type-guard';

export const toRem = (value: number): string => `${value / 16}rem`;

export const formatFileSize = (size: number): string => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let index = 0;
  while (size >= 1024 && index < units.length - 1) {
    size /= 1024;
    index++;
  }
  return `${size.toFixed(2)} ${units[index]}`;
};

/**
 * 파일명 트렁케이트 (Array.from 기반)
 * - 한글 받침 깨짐 방지
 * - 확장자(.pdf, .jpg 등) 유지
 */
export function truncateFileNameByArray(text: string, maxLength: number, suffix = '...'): string {
  const extIndex = text.lastIndexOf('.');
  const ext = extIndex === -1 ? '' : text.slice(extIndex);
  const name = extIndex === -1 ? text : text.slice(0, extIndex);

  const chars = Array.from(name);
  if (chars.length <= maxLength) return text;

  return chars.slice(0, maxLength).join('') + suffix + ext;
}

/**
 * 파일명 트렁케이트 (Intl.Segmenter 기반)
 * - grapheme 단위로 자르기
 * - 받침, 이모지 등 완벽 보존
 */
export function truncateFileNameBySegmenter(
  text: string,
  maxLength: number,
  suffix = '...'
): string {
  const extIndex = text.lastIndexOf('.');
  const ext = extIndex === -1 ? '' : text.slice(extIndex);
  const name = extIndex === -1 ? text : text.slice(0, extIndex);

  const segmenter = new Intl.Segmenter('ko', { granularity: 'grapheme' });
  const graphemes = [...segmenter.segment(name)].map((seg) => seg.segment);

  if (graphemes.length <= maxLength) return text;
  return graphemes.slice(0, maxLength).join('') + suffix + ext;
}

/**
 * 파일명 트렁케이트 (자동 폴백)
 */
export function truncateFileName(text: string, maxLength: number, suffix = '...'): string {
  if (typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function') {
    return truncateFileNameBySegmenter(text, maxLength, suffix);
  }
  return truncateFileNameByArray(text, maxLength, suffix);
}
